<div class="ind-page">
  <div class="ind-card">

    <!-- Header -->
    <div class="ind-header">
      <div class="ind-header-info">
        <div class="ind-avatar">{{ indService.indDetail.IndividualTab.Individual.FULLNAME | slice:0:2 | uppercase }}
        </div>
        <div>
          <h1 class="ind-title">Individual Maintenance</h1>
          <p class="ind-subtitle">{{ indService.indDetail.IndividualTab.Individual.FULLNAME }}</p>
        </div>
      </div>
      <div class="ind-header-actions">
        <button mat-raised-button color="primary" (click)="saveIndividual()">
          Save
        </button>
        <button mat-stroked-button color="accent" (click)="reset()" [disabled]="!indService.editMode">
          <mat-icon>refresh</mat-icon> Reset
        </button>
        <button mat-stroked-button color="accent" routerLink="/individualmaintenance/1">
          Back
        </button>
      </div>
    </div>

    <!-- Tab Group -->
    <mat-tab-group color="accent" backgroundColor="primary" class="ind-tab-group">

      <!-- ─────────────── Individual Tab ─────────────── -->
      <mat-tab label="Individual">
        <div class="tab-body">

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Full Name</label>
              <mat-form-field appearance="outline" class="form-field-full">
                <input matInput placeholder="Full Name"
                  [(ngModel)]="indService.indDetail.IndividualTab.Individual.FULLNAME"
                  [disabled]="isOrganizationFieldsDisabled" />
              </mat-form-field>
            </div>
            <div class="form-group">
              <label class="form-label">Organization</label>
              <mat-form-field appearance="outline" class="form-field-full">
                <mat-select [(ngModel)]="indService.indDetail.IndividualTab.Individual.SELECTEDORGCODE"
                  [disabled]="isOrganizationFieldsDisabled">
                  <mat-option *ngFor="let org of indService.indDetail.IndividualTab.Individual.ORGANIZATIONLIST"
                    [value]="org.CODE">{{ org.DESCRIPTION }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="two-panel-row">

            <!-- Phone -->
            <div class="section-card">
              <div class="section-header">
                <span class="section-title">Phone</span>
              </div>
              <table mat-table [dataSource]="dataSourcePhone" class="ind-table">
                <ng-container matColumnDef="Type">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let phone">{{ phone.SELECTEDPHONETYPEDESCRIPTION }}</td>
                </ng-container>
                <ng-container matColumnDef="Number">
                  <th mat-header-cell *matHeaderCellDef>Number</th>
                  <td mat-cell *matCellDef="let phone">({{ phone.AREACODE }}) {{ phone.EXCHANGE }}-{{ phone.PNUMBER }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="extension">
                  <th mat-header-cell *matHeaderCellDef>Ext</th>
                  <td mat-cell *matCellDef="let phone">{{ phone.EXTENSION }}</td>
                </ng-container>
                <ng-container matColumnDef="Edit">
                  <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                  <td mat-cell *matCellDef="let phone; let i = index" class="col-action">
                    <button mat-icon-button class="action-btn edit-btn" (click)="editPhone(i)"
                      [disabled]="isOrganizationFieldsDisabled" matTooltip="Edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Delete">
                  <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                  <td mat-cell *matCellDef="let phone; let i = index" class="col-action">
                    <button mat-icon-button class="action-btn del-btn" (click)="deletePhone(i)"
                      [disabled]="isOrganizationFieldsDisabled" *ngIf="phone.PHONE_ID == null" matTooltip="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsPhone"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsPhone;"></tr>
              </table>
              <div class="section-footer">
                <button mat-raised-button color="primary" (click)="addPhone()"
                  [disabled]="isOrganizationFieldsDisabled">
                  <mat-icon>add</mat-icon> Add Phone
                </button>
              </div>
            </div>

            <!-- Email -->
            <div class="section-card">
              <div class="section-header">
                <span class="section-title">Email</span>
              </div>
              <table mat-table [dataSource]="dataSourceEmail" class="ind-table">
                <ng-container matColumnDef="Email">
                  <th mat-header-cell *matHeaderCellDef>Email Address</th>
                  <td mat-cell *matCellDef="let email">{{ email.EMAILADDRESS }}</td>
                </ng-container>
                <ng-container matColumnDef="Edit">
                  <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                  <td mat-cell *matCellDef="let email; let i = index" class="col-action">
                    <button mat-icon-button class="action-btn edit-btn" (click)="editEmail(i)"
                      [disabled]="isOrganizationFieldsDisabled" matTooltip="Edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Delete">
                  <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                  <td mat-cell *matCellDef="let element; let i = index" class="col-action">
                    <button mat-icon-button class="action-btn del-btn" (click)="deleteEmail(i)"
                      [disabled]="isOrganizationFieldsDisabled" *ngIf="element.EMAIL_ID == null" matTooltip="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsEmail"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsEmail;"></tr>
              </table>
              <div class="section-footer">
                <button mat-raised-button color="primary" (click)="addEmail()"
                  [disabled]="isOrganizationFieldsDisabled">
                  <mat-icon>add</mat-icon> Add Email
                </button>
              </div>
            </div>

          </div><!-- /two-panel-row -->

          <!-- Address -->
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Address</span>
            </div>
            <table mat-table [dataSource]="dataSourceAddress" class="ind-table">
              <ng-container matColumnDef="Type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let address">{{ address.SELECTEDADDRTYPEDESCRIPTION }}</td>
              </ng-container>
              <ng-container matColumnDef="Address">
                <th mat-header-cell *matHeaderCellDef>Address</th>
                <td mat-cell *matCellDef="let address">
                  {{ address.STREETNUMBER }} {{ address.STREETNAME }} {{ address.STREETTYPE }},
                  {{ address.CITY }}, {{ address.STATEPROVINCE }} {{ address.ZIP }}
                </td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let address; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="editAddress(i)"
                    [disabled]="isOrganizationFieldsDisabled" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let element; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteAddress(i)"
                    [disabled]="isOrganizationFieldsDisabled" *ngIf="element.ADDRESS_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsAddress"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsAddress;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addAddress()"
                [disabled]="isOrganizationFieldsDisabled">
                <mat-icon>add</mat-icon> Add Address
              </button>
            </div>
          </div>

        </div>
      </mat-tab>

      <!-- ─────────────── Roles Tab ─────────────── -->
      <mat-tab label="Roles">
        <div class="tab-body">
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Roles</span>
            </div>
            <table mat-table [dataSource]="dataSourceRoles" class="ind-table">
              <ng-container matColumnDef="Role">
                <th mat-header-cell *matHeaderCellDef>Role</th>
                <td mat-cell *matCellDef="let role">{{ role.SELECTEDROLEDESCRIPTION }}</td>
              </ng-container>
              <ng-container matColumnDef="EndDate">
                <th mat-header-cell *matHeaderCellDef>End Date</th>
                <td mat-cell *matCellDef="let role">{{ role.LASTDATE | date:'shortDate' }}</td>
              </ng-container>
              <ng-container matColumnDef="Inventory">
                <th mat-header-cell *matHeaderCellDef>Inventory</th>
                <td mat-cell *matCellDef="let role">
                  <span class="check-badge" *ngIf="role.INVENTORY">✓</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Active">
                <th mat-header-cell *matHeaderCellDef>Active</th>
                <td mat-cell *matCellDef="let role">
                  <span class="check-badge" *ngIf="role.WORKRESOURCE_ACTIVE">✓</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="Certification">
                <th mat-header-cell *matHeaderCellDef>Certification</th>
                <td mat-cell *matCellDef="let role">
                  <span class="check-badge" *ngIf="role.CERTIFICATION">✓</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="ViewKeys">
                <th mat-header-cell *matHeaderCellDef>View Keys</th>
                <td mat-cell *matCellDef="let role">
                  <button mat-icon-button class="action-btn info-btn" (click)="viewClientKeys(role)"
                    matTooltip="View Client Keys">
                    <mat-icon>privacy_tip</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let role; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="editRoles(i)" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let element; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteRoles(i)"
                    *ngIf="element.WORKRESOURCE_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsRoles"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsRoles;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addRoles()" [disabled]="isOrganizationFieldsDisabled">
                <mat-icon>add</mat-icon> Add Role
              </button>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ─────────────── Grids Tab ─────────────── -->
      <mat-tab label="Grids">
        <div class="tab-body">
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Grids</span>
            </div>
            <table mat-table [dataSource]="dataSourceGrids" class="ind-table">
              <ng-container matColumnDef="Grid">
                <th mat-header-cell *matHeaderCellDef>Grid</th>
                <td mat-cell *matCellDef="let grid">{{ grid.SELECTEDGRIDDESCRIPTION }}</td>
              </ng-container>
              <ng-container matColumnDef="EndDate">
                <th mat-header-cell *matHeaderCellDef>End Date</th>
                <td mat-cell *matCellDef="let grid">{{ grid.ENDDATE | date:'shortDate' }}</td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let grid; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="editGrids(i)" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let element; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteGrids(i)"
                    *ngIf="element.RESOURCEGRID_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsGrids"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsGrids;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addGrids()">
                <mat-icon>add</mat-icon> Add Grid
              </button>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ─────────────── Daily Hours Tab ─────────────── -->
      <mat-tab label="Daily Hours">
        <div class="tab-body">
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Daily Hours</span>
            </div>
            <table mat-table [dataSource]="dataSourceDailyHours" class="ind-table">
              <ng-container matColumnDef="dotw">
                <th mat-header-cell *matHeaderCellDef>Day of the Week</th>
                <td mat-cell *matCellDef="let dailyhours">{{ dailyhours.SELECTEDDAYOFWEEKDESC }}</td>
              </ng-container>
              <ng-container matColumnDef="Start">
                <th mat-header-cell *matHeaderCellDef>Start</th>
                <td mat-cell *matCellDef="let dailyhours">{{ dailyhours.STARTDATE | date:'short' }}</td>
              </ng-container>
              <ng-container matColumnDef="End">
                <th mat-header-cell *matHeaderCellDef>End</th>
                <td mat-cell *matCellDef="let dailyhours">{{ dailyhours.ENDDATE | date:'short' }}</td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let role; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="editDailyHours(i)" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let dailyhours; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteDailyHours(i)"
                    *ngIf="dailyhours.DAILYHOURS_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsDailyHours"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsDailyHours;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addDailyHours()">
                <mat-icon>add</mat-icon> Add Hours
              </button>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ─────────────── Time Off Tab ─────────────── -->
      <mat-tab label="Time Off">
        <div class="tab-body">
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Time Off</span>
            </div>
            <table mat-table [dataSource]="dataSourceTimeOff" class="ind-table">
              <ng-container matColumnDef="Start">
                <th mat-header-cell *matHeaderCellDef>Start</th>
                <td mat-cell *matCellDef="let timeoff">{{ timeoff.STARTTIME | date:'short' }}</td>
              </ng-container>
              <ng-container matColumnDef="End">
                <th mat-header-cell *matHeaderCellDef>End</th>
                <td mat-cell *matCellDef="let timeoff">{{ timeoff.ENDTIME | date:'short' }}</td>
              </ng-container>
              <ng-container matColumnDef="Reason">
                <th mat-header-cell *matHeaderCellDef>Reason</th>
                <td mat-cell *matCellDef="let timeoff">{{ timeoff.NOTES }}</td>
              </ng-container>
              <ng-container matColumnDef="User">
                <th mat-header-cell *matHeaderCellDef>User</th>
                <td mat-cell *matCellDef="let timeoff">{{ timeoff.USER_ID }}</td>
              </ng-container>
              <ng-container matColumnDef="DateEntered">
                <th mat-header-cell *matHeaderCellDef>Date Entered</th>
                <td mat-cell *matCellDef="let timeoff">{{ timeoff.STATUSDATESYS | date:'shortDate' }}</td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let role; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="editTimeOff(i)" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let timeoff; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteTimeOff(i)"
                    *ngIf="timeoff.TIMEOFF_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsTimeOff"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsTimeOff;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addTimeOff()">
                <mat-icon>add</mat-icon> Add Time Off
              </button>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ─────────────── Additional Hours Tab ─────────────── -->
      <mat-tab label="Additional Hours">
        <div class="tab-body">
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Additional Hours</span>
            </div>
            <table mat-table [dataSource]="dataSourceAdditionalHours" class="ind-table">
              <ng-container matColumnDef="Start">
                <th mat-header-cell *matHeaderCellDef>Start Time</th>
                <td mat-cell *matCellDef="let addhours">{{ addhours.STARTTIME | date:'short' }}</td>
              </ng-container>
              <ng-container matColumnDef="End">
                <th mat-header-cell *matHeaderCellDef>End Time</th>
                <td mat-cell *matCellDef="let addhours">{{ addhours.ENDTIME | date:'short' }}</td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let role; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="editAdditionalHours(i)"
                    matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef class="col-action"></th>
                <td mat-cell *matCellDef="let element; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteAdditionalHours(i)"
                    *ngIf="element.ADDITIONALHOURS_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsAdditionalHours"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsAdditionalHours;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addAdditionalHours()">
                <mat-icon>add</mat-icon> Add Additional Hours
              </button>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ─────────────── Bucket Scheduling Tab ─────────────── -->
      <mat-tab label="Bucket Scheduling" *ngIf="isBucketEnabled">
        <div class="tab-body">
          <div class="section-card">
            <div class="section-header">
              <span class="section-title">Bucket Scheduling</span>
            </div>
            <table mat-table [dataSource]="dataSourceBucketScheduling" class="ind-table bucket-table">
              <ng-container matColumnDef="workorder">
                <th mat-header-cell *matHeaderCellDef>Workorder</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.SELECTEDWOTYPEDESC }}</td>
              </ng-container>
              <ng-container matColumnDef="grid">
                <th mat-header-cell *matHeaderCellDef>Grid</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.SELECTEDGRIDDESC }}</td>
              </ng-container>
              <ng-container matColumnDef="timeslot">
                <th mat-header-cell *matHeaderCellDef>Time Slot</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.TIMESLOT_NAME }}</td>
              </ng-container>
              <ng-container matColumnDef="apptqty">
                <th mat-header-cell *matHeaderCellDef>Qty</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.TIMESLOT_QTY }}</td>
              </ng-container>
              <ng-container matColumnDef="startdate">
                <th mat-header-cell *matHeaderCellDef>Start</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.STARTDATE | date:'shortDate' }}</td>
              </ng-container>
              <ng-container matColumnDef="enddate">
                <th mat-header-cell *matHeaderCellDef>End</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.ENDDATE | date:'shortDate' }}</td>
              </ng-container>
              <ng-container matColumnDef="apptstart">
                <th mat-header-cell *matHeaderCellDef>Appt Start</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.APPTSTARTTIME | date:'shortTime' }}</td>
              </ng-container>
              <ng-container matColumnDef="apptend">
                <th mat-header-cell *matHeaderCellDef>Appt End</th>
                <td mat-cell *matCellDef="let bucket">{{ bucket.APPTENDTIME | date:'shortTime' }}</td>
              </ng-container>
              <ng-container matColumnDef="sun">
                <th mat-header-cell *matHeaderCellDef>Sun</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.SUNDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="mon">
                <th mat-header-cell *matHeaderCellDef>Mon</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.MONDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="tues">
                <th mat-header-cell *matHeaderCellDef>Tue</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.TUESDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="wed">
                <th mat-header-cell *matHeaderCellDef>Wed</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.WEDNESDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="thur">
                <th mat-header-cell *matHeaderCellDef>Thu</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.THURSDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="fri">
                <th mat-header-cell *matHeaderCellDef>Fri</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.FRIDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="sat">
                <th mat-header-cell *matHeaderCellDef>Sat</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.SATURDAY">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="modifiable">
                <th mat-header-cell *matHeaderCellDef>Mod</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.MODIFIABLE">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="deactivate">
                <th mat-header-cell *matHeaderCellDef>Deactivate</th>
                <td mat-cell *matCellDef="let bucket"><span class="day-check" *ngIf="bucket.DEACTIVATEROW">✓</span></td>
              </ng-container>
              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef class="col-action">Actions</th>
                <td mat-cell *matCellDef="let bucket; let i = index" class="col-action">
                  <button mat-icon-button class="action-btn edit-btn" (click)="deactivateBucketScheduling(i)"
                    [disabled]="bucket.DEACTIVATEROW == true" *ngIf="bucket.WEBTIMESLOTSETUP_ID != null"
                    matTooltip="Toggle Active">
                    <mat-icon *ngIf="bucket.DEACTIVATEROW">toggle_off</mat-icon>
                    <mat-icon *ngIf="!bucket.DEACTIVATEROW">toggle_on</mat-icon>
                  </button>
                  <button mat-icon-button class="action-btn edit-btn" (click)="editBucketScheduling(i)"
                    *ngIf="bucket.WEBTIMESLOTSETUP_ID == null" matTooltip="Edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button class="action-btn del-btn" (click)="deleteBucketScheduling(i)"
                    *ngIf="bucket.WEBTIMESLOTSETUP_ID == null" matTooltip="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsBucketScheduling"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsBucketScheduling;"></tr>
            </table>
            <div class="section-footer">
              <button mat-raised-button color="primary" (click)="addBucketScheduling()">
                <mat-icon>add</mat-icon> Add Bucket
              </button>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>
</div>